export function limit<T>(arr: T[], maxCount?: number) {
  return maxCount && maxCount < arr.length ? arr.slice(-1 * maxCount) : arr;
}
